<template>
  <div>
    <div class="setting-router-title">隐私设置</div>
    <div class="setting-main">
      <h3>图片水印</h3>
      <div class="tips">
        我上传的图片上水印显示昵称<a-switch v-model:checked="privacyStatus" />
      </div>
      <div class="tips">
        在你的论文解读，文章，提问等模块，添加的图片将会被打上水印，正常情况下如左图，匿名和隐藏昵称的情况下，如下图
      </div>
      <div class="pics">
        <a-row>
          <a-col :span="12">
            <dl>
              <dt>
                <img src="~@/assets/img/soz_zt.jpg" alt="" />
                <div class="text">@知图 {{ userInfo.userName }}</div>
              </dt>
              <dd>正常状态下</dd>
            </dl>
          </a-col>
          <a-col :span="12">
            <dl>
              <dt>
                <img src="~@/assets/img/soz_zt.jpg" alt="" />
                <div class="text">@知图</div>
              </dt>
              <dd>匿名或隐藏状态下</dd>
            </dl>
          </a-col>
        </a-row>
      </div>
      <div class="divider-line"></div>
      <div style="text-align: center">
        <a-button type="primary" @click="changePrivate">保存</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted, watchEffect } from "vue";
import Http from "../../until/http";
import { setLocalItem, messageTips } from "../../until/tools";
export default defineComponent({
  setup() {
    const state = reactive({
      showNickName: false,
      privacyStatus: null,
      userInfo: {},
    });
    watchEffect(()=>{
      // console.log(state.privacyStatus);
    })
    const changePrivate = () => {
      Http.changePrivateState({
        privacyStatus: state.privacyStatus ? 1 : 0,
      }).then((res) => {
        if (res) {
          if (res.success) {
            messageTips(res.message, 3);
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };
    const getUserInfo = () => {
      Http.getUserInfo().then((res) => {
        if (res.userInfo) {
          setLocalItem("userInfo", res.userInfo);
          Object.assign(state, {
            userInfo: res.userInfo,
            privacyStatus: res.userInfo.privacyStatus==1?true:false,
          });
        }
      });
    };
    onMounted(() => {
        getUserInfo()
    });

    return {
      ...toRefs(state),
      changePrivate,
      getUserInfo
    };
  },
});
</script>

<style>
</style>